import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ENPOINT } from '../endpoint';

import { GLOBAL } from '../global';

@Injectable()
export class IndicadorImpuestosService {
  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  getIndicadoresDeImpuestos(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(`${this.basePath}indicadores-impuestos-extrajeros`, options);
  }

  getInidicadorDeImpuesto(indicador): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('indicador', indicador)
    };
    return this.http.get(`${this.basePath}indicadores-impuestos-extrajeros`, options);
  }

  postIndicadorDeImpuesto(body): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(`${this.basePath}indicadores-impuestos-extrajeros`, body, options);
  }

  updateIndicadorDeImpuesto(data): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.put(`${this.basePath}indicadores-impuestos-extrajeros`, data, options);
  }

  deleteIndicadorDeImpuesto(id): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('indicador', id)
    };
    return this.http.delete(`${this.basePath}indicadores-impuestos-extrajeros`, options);
  }

  getFacturaUUID(uuid): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      observe: 'response' as 'response',
      params: new HttpParams()
      .set('uuid', uuid)
    };
    return this.http.get(`${this.basePath}indicadores-impuestos-extrajeros/factura`, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/indicador-impuestos/indicador-impuestos.service.ts